/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PaymentStartSubscriptionInput = {|
  corpoRef: string,
  planType: string,
  paymentType: string,
  setupIntentId?: ?string,
|};
export type PaymentCorpoStartSubscriptionMutationVariables = {|
  input: PaymentStartSubscriptionInput
|};
export type PaymentCorpoStartSubscriptionMutationResponse = {|
  +payment: ?{|
    +corpo: ?{|
      +res: ?{|
        +code: number,
        +message: string,
        +data: ?any,
      |}
    |}
  |}
|};
export type PaymentCorpoStartSubscriptionMutation = {|
  variables: PaymentCorpoStartSubscriptionMutationVariables,
  response: PaymentCorpoStartSubscriptionMutationResponse,
|};
*/


/*
mutation PaymentCorpoStartSubscriptionMutation(
  $input: PaymentStartSubscriptionInput!
) {
  payment {
    corpo {
      res: startSubscription(input: $input) {
        code
        message
        data
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PaymentMutation",
    "kind": "LinkedField",
    "name": "payment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentCorpoMutation",
        "kind": "LinkedField",
        "name": "corpo",
        "plural": false,
        "selections": [
          {
            "alias": "res",
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "PaymentPaymentPayload",
            "kind": "LinkedField",
            "name": "startSubscription",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "data",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentCorpoStartSubscriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentCorpoStartSubscriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1724f0717fcfe496e539754ed1af7de5",
    "id": null,
    "metadata": {},
    "name": "PaymentCorpoStartSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation PaymentCorpoStartSubscriptionMutation(\n  $input: PaymentStartSubscriptionInput!\n) {\n  payment {\n    corpo {\n      res: startSubscription(input: $input) {\n        code\n        message\n        data\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b467a92c78f59732aaab169706351add';

module.exports = node;
